import { render, staticRenderFns } from "./ClientOverview_listItemActivityType.vue?vue&type=template&id=3b207779&scoped=true&"
import script from "./ClientOverview_listItemActivityType.vue?vue&type=script&lang=js&"
export * from "./ClientOverview_listItemActivityType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b207779",
  null
  
)

export default component.exports